import script from "./ageCheckFailed.vue?vue&type=script&lang=ts&setup=true"
export * from "./ageCheckFailed.vue?vue&type=script&lang=ts&setup=true"

import "./ageCheckFailed.vue?vue&type=style&index=0&id=0e3be91e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e3be91e"]])

export default __exports__